import Loadable from 'react-loadable';

import Loading from '../commons/components/Loading';

import {
  ADMIN_POI_TEMPLATE,
  ADMIN_SCENE_LINK,
  ADMIN_TOUR_LINK,
  CMS_WEB_ROTATE_LINK,
  CONFIG_TOUR_LINK,
  DASHBOARD_LINK,
  DRAFT_TOUR_LINK,
  ICON_LIBRARY,
  ITEM_INFO_LINK,
  NOT_FOUND_LINK,
  PROMOTION_LINK,
  SCENE_LINK,
  THEME_LINK,
  TOUR_GUIDE_CONFIG,
  TOUR_LINK,
  USER_CONTACTS,
} from '../commons/constants/links';
import {
  PERMISSION_CONFIG_TOUR,
  PERMISSION_CREATE_DRAFT_TOUR,
  PERMISSION_CREATE_ITEM_INFO,
  PERMISSION_CREATE_PROMOTION,
  PERMISSION_CREATE_PUBLIC_ICON_TEMPLATE,
  PERMISSION_CREATE_SCENE,
  PERMISSION_CREATE_TOUR,
  PERMISSION_CREATE_TOUR_GUIDE,
  PERMISSION_CREATE_WEB_ROTATE,
  PERMISSION_DELETE_WEB_ROTATE,
  PERMISSION_UPDATE_WEB_ROTATE,
  PERMISSION_VIEW_ALL_SCENES,
  PERMISSION_VIEW_ALL_TOURS,
  PERMISSION_VIEW_DRAFT_TOURS,
  PERMISSION_VIEW_ITEM_INFOS,
  PERMISSION_VIEW_PROMOTIONS,
  PERMISSION_VIEW_SCANNABLE_DRAFT_TOURS,
  PERMISSION_VIEW_SCENES,
  PERMISSION_VIEW_TOUR_GUIDES,
  PERMISSION_VIEW_TOURS,
  PERMISSION_VIEW_WEB_ROTATE,
} from '../commons/constants/permissions';

const loadable = (
  loader: () => Promise<React.ComponentType<any> | { default: React.ComponentType<any> }>,
) =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loading />,
  });

export default {
  // Dashboard
  [DASHBOARD_LINK]: {
    component: loadable(() => import('../pages/Dashboard')),
  },
  '/dashboard': {
    component: loadable(() => import('../pages/Dashboard')),
  },

  // default pages
  [NOT_FOUND_LINK]: {
    component: loadable(() => import('../pages/DefaultPages/NotFoundPage')),
  },

  // Pages
  [SCENE_LINK]: {
    component: loadable(() => import('../pages/SceneManagement')),
    permissions: [PERMISSION_VIEW_SCENES, PERMISSION_CREATE_SCENE],
  },
  [TOUR_LINK]: {
    component: loadable(() => import('../pages/TourManagement')),
    permissions: [PERMISSION_VIEW_TOURS, PERMISSION_CREATE_TOUR],
  },
  [CONFIG_TOUR_LINK]: {
    component: loadable(() => import('../pages/ConfigureTour')),
    permissions: [PERMISSION_CONFIG_TOUR],
  },
  [TOUR_GUIDE_CONFIG]: {
    component: loadable(() => import('../pages/TourGuideConfig')),
    permissions: [PERMISSION_VIEW_TOUR_GUIDES, PERMISSION_CREATE_TOUR_GUIDE],
  },
  [USER_CONTACTS]: {
    component: loadable(() => import('../pages/AccountPage')),
  },
  [ICON_LIBRARY]: {
    component: loadable(() => import('../pages/IconLibrary')),
  },
  [THEME_LINK]: {
    component: loadable(() => import('../pages/ThemeManagement')),
    permissions: [PERMISSION_CREATE_PUBLIC_ICON_TEMPLATE],
  },
  [ADMIN_SCENE_LINK]: {
    component: loadable(() => import('../pages/SceneAdminManagement')),
    permissions: [PERMISSION_VIEW_ALL_SCENES],
  },
  [ADMIN_TOUR_LINK]: {
    component: loadable(() => import('../pages/TourAdminManagement')),
    permissions: [PERMISSION_VIEW_ALL_TOURS],
  },
  [DRAFT_TOUR_LINK]: {
    component: loadable(() => import('../pages/DraftTourManagement')),
    permissions: [PERMISSION_VIEW_DRAFT_TOURS, PERMISSION_CREATE_DRAFT_TOUR, PERMISSION_VIEW_SCANNABLE_DRAFT_TOURS],
  },
  [CMS_WEB_ROTATE_LINK]: {
    component: loadable(() => import('../pages/CMSWebRotateManagement')),
    permissions: [
      PERMISSION_VIEW_WEB_ROTATE,
      PERMISSION_CREATE_WEB_ROTATE,
      PERMISSION_UPDATE_WEB_ROTATE,
      PERMISSION_DELETE_WEB_ROTATE,
    ],
  },
  [ITEM_INFO_LINK]: {
    component: loadable(() => import('../pages/ItemInfoManagement')),
    permissions: [PERMISSION_VIEW_ITEM_INFOS, PERMISSION_CREATE_ITEM_INFO],
  },
  [PROMOTION_LINK]: {
    component: loadable(() => import('../pages/PromotionManagement')),
    permissions: [PERMISSION_VIEW_PROMOTIONS, PERMISSION_CREATE_PROMOTION],
  },
  [ADMIN_POI_TEMPLATE]: {
    component: loadable(() => import('../pages/PoiTemplateManagement')),
  },
};
